import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Stats
export const adminGetStats          = ()      => api.get("/api/v1/admin/stats/");

// Users
export const adminGetUsers          = (p={})  => api.get("/api/v1/admin/users/",           { params: p });
export const adminGetUser           = (id)    => api.get(`/api/v1/admin/users/${id}/`);
export const adminUpdateUser        = (id, d) => api.patch(`/api/v1/admin/users/${id}/`,   d);
export const adminSetRole           = (id, d) => api.post(`/api/v1/admin/users/${id}/set-role/`, d);
export const adminToggleActive      = (id)    => api.post(`/api/v1/admin/users/${id}/toggle-active/`);

// Markets
export const adminGetMarkets        = (p={})  => api.get("/api/v1/admin/markets/",         { params: p });
export const adminCreateMarket = (d) => {
  const isFormData = d instanceof FormData;
  return api.post("/api/v1/admin/markets/", d, isFormData
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : undefined
  );
};

export const adminUpdateMarket = (id, d) => {
  const isFormData = d instanceof FormData;
  return api.patch(`/api/v1/admin/markets/${id}/`, d, isFormData
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : undefined
  );
};
export const adminDeleteMarket      = (id)    => api.delete(`/api/v1/admin/markets/${id}/`);
export const adminPublishMarket     = (id)    => api.post(`/api/v1/admin/markets/${id}/publish/`);
export const adminCloseMarket       = (id)    => api.post(`/api/v1/admin/markets/${id}/close/`);
export const adminResolveMarket     = (id, d) => api.post(`/api/v1/admin/markets/${id}/resolve/`,  d);
export const adminCancelMarket      = (id, d) => api.post(`/api/v1/admin/markets/${id}/cancel/`,   d);

// Priorité automatique aléatoire des marchés (toutes les 24h, activable/désactivable)
export const adminGetMarketPriorityAuto = ()        => api.get("/api/v1/admin/markets/priority-auto/");
export const adminSetMarketPriorityAuto = (enabled) => api.patch("/api/v1/admin/markets/priority-auto/", { enabled });

// Categories
export const adminGetCategories     = ()      => api.get("/api/v1/admin/categories/");
export const adminCreateCategory    = (d)     => api.post("/api/v1/admin/categories/",     d);
export const adminDeleteCategory    = (id)    => api.delete(`/api/v1/admin/categories/${id}/`);

// Withdrawals
export const adminGetWithdrawals    = (p={})  => api.get("/api/v1/admin/withdrawals/",     { params: p });
export const adminApproveWithdrawal = (id)    => api.post(`/api/v1/admin/withdrawals/${id}/approve/`);
export const adminRejectWithdrawal  = (id, d) => api.post(`/api/v1/admin/withdrawals/${id}/reject/`, d);

// ── Admin: UX Analytics ───────────────────────────────────────────────────────
export const adminGetUXOverview    = (range="30d") => api.get("/api/v1/admin/ux/overview/",    { params:{range} });
export const adminGetUXFunnel      = (range="30d") => api.get("/api/v1/admin/ux/funnel/",      { params:{range} });
export const adminGetUXClicks      = (range="30d") => api.get("/api/v1/admin/ux/clicks/",      { params:{range} });
export const adminGetUXActivation  = (range="30d") => api.get("/api/v1/admin/ux/activation/",  { params:{range} });
export const adminGetUXEngagement  = (range="30d") => api.get("/api/v1/admin/ux/engagement/",  { params:{range} });
export const adminGetUXCohorts     = ()            => api.get("/api/v1/admin/ux/cohorts/");
export const adminGetUXErrors      = (range="30d") => api.get("/api/v1/admin/ux/errors/",      { params:{range} });
export const adminGetUXLatency     = (range="30d") => api.get("/api/v1/admin/ux/latency/",     { params:{range} });
export const adminGetUXDevices     = (range="30d") => api.get("/api/v1/admin/ux/devices/",     { params:{range} });
export const adminGetUXBehavioral  = (range="30d") => api.get("/api/v1/admin/ux/behavioral/",  { params:{range} });

// ═════════════════════════════════════════════════════════════════════════════
// PATCH 2 — Ajouter à la fin de adminClient.js, AVANT `export default api;`
// ═════════════════════════════════════════════════════════════════════════════

/* ─── Admin: Mobile Withdrawals ───────────────────────────────────────────── */
export const adminGetPayouts      = (p={})  => api.get("/api/v1/admin/withdrawals/payouts/",                      { params: p });
export const adminApprovePayout   = (id, d) => api.post(`/api/v1/admin/withdrawals/payouts/${id}/approve/`,       d);
export const adminCompletePayout  = (id, d) => api.post(`/api/v1/admin/withdrawals/payouts/${id}/complete/`,      d);
export const adminRejectPayout    = (id, d) => api.post(`/api/v1/admin/withdrawals/payouts/${id}/reject/`,        d);


export const adminGetReferralCodes        = ()       => api.get("/api/v1/admin/referral/");
export const adminUpdateReferralCode      = (id, d)  => api.patch(`/api/v1/admin/referral/codes/${id}/`, d);
export const adminGetCommissions          = (p={})   => api.get("/api/v1/admin/referral/commissions/", { params: p });
export const adminApproveCommission       = (id)     => api.post(`/api/v1/admin/referral/commissions/${id}/approve/`);
export const adminRejectCommission        = (id, d)  => api.post(`/api/v1/admin/referral/commissions/${id}/reject/`, d);
export const adminFlagReferralRelation    = (id, d)  => api.post(`/api/v1/admin/referral/relations/${id}/flag/`, d);

export const adminGetReferralStats     = ()                  => api.get("/api/v1/admin/referrals/stats/");
export const adminGetReferralList      = (params)            => api.get("/api/v1/admin/referrals/", { params });
export const adminGetReferralDetail    = (userId)            => api.get(`/api/v1/admin/referrals/code/${userId}/`);
export const adminFlagRelation         = (id, body)          => api.post(`/api/v1/admin/referrals/relations/${id}/flag/`, body);

export const adminAutoTranslate = (text, source_lang = "fr") =>
  api.post("/api/v1/admin/translate/", { text, source_lang });

/* ─── Email — Overview ─────────────────────────────────────────────────── */
export const adminGetEmailOverview = () =>
  api.get("/api/v1/admin/email/overview/");

/* ─── Email — Campaigns CRUD ───────────────────────────────────────────── */
export const adminListEmailCampaigns = (params) =>
  api.get("/api/v1/admin/email/campaigns/", { params });

export const adminCreateEmailCampaign = (data) =>
  api.post("/api/v1/admin/email/campaigns/", data);

export const adminGetEmailCampaign = (id) =>
  api.get(`/api/v1/admin/email/campaigns/${id}/`);

export const adminUpdateEmailCampaign = (id, data) =>
  api.patch(`/api/v1/admin/email/campaigns/${id}/`, data);

export const adminDeleteEmailCampaign = (id) =>
  api.delete(`/api/v1/admin/email/campaigns/${id}/`);

/* ─── Email — Campaign actions ─────────────────────────────────────────── */
export const adminPreviewEmailCampaign = (id, data) =>
  api.post(`/api/v1/admin/email/campaigns/${id}/preview/`, data);

export const adminTestEmailCampaign = (id, data) =>
  api.post(`/api/v1/admin/email/campaigns/${id}/test/`, data);

export const adminSendEmailCampaign = (id) =>
  api.post(`/api/v1/admin/email/campaigns/${id}/send/`);

export const adminScheduleEmailCampaign = (id, data) =>
  api.post(`/api/v1/admin/email/campaigns/${id}/schedule/`, data);

export const adminCancelEmailCampaign = (id) =>
  api.post(`/api/v1/admin/email/campaigns/${id}/cancel/`);

export const adminGetCampaignRecipients = (id, params) =>
  api.get(`/api/v1/admin/email/campaigns/${id}/recipients/`, { params });

export const adminGetCampaignStats = (id) =>
  api.get(`/api/v1/admin/email/campaigns/${id}/stats/`);

/* ─── Email — Segmentation ─────────────────────────────────────────────── */
export const adminCountEmailSegment = (filters) =>
  api.post("/api/v1/admin/email/segments/count/", { filters });

/* ─── Email — Templates (transactionnels) ──────────────────────────────── */
export const adminListEmailTemplates = () =>
  api.get("/api/v1/admin/email/templates/");

export const adminGetEmailTemplate = (code) =>
  api.get(`/api/v1/admin/email/templates/${code}/`);

export const adminTestEmailTemplate = (code, data) =>
  api.post(`/api/v1/admin/email/templates/${code}/test/`, data);

/* ─── Email — Audit ────────────────────────────────────────────────────── */
export const adminListEmailUnsubscribes = (params) =>
  api.get("/api/v1/admin/email/unsubscribes/", { params });

export const adminListEmailLogs = (params) =>
  api.get("/api/v1/admin/email/logs/", { params });

export const adminUpdateCategory = (id, data) =>
  api.patch(`/api/v1/admin/categories/${id}/`, data);

export const adminGetUXVolume = (range = "30d") =>
  api.get(`/api/v1/admin/ux/volume/`, { params: { range } });

export const adminGetUXByCountry = (range = "30d") =>
  api.get(`/api/v1/admin/ux/by-country/`, { params: { range } });

export default api;